import { upsertCustomerFeedback } from "features/journey-map/reducer/CJMActions";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Spinner } from "shared/components/spinners/Spinner";
import GenericSwitch from "shared/ui-basics/buttons";
import { IconDispatcher, Label } from "shared/ui-basics/index";
import { EmotionLevelAndSmiley } from "shared/ui-basics/ui-components/EmotionLevelComponents/EmotionLevelAndSmiley";
import styled from "styled-components";
import * as Styles from "../Styles";

export const FeedBackData = ({ feedback, showStopRetrieveData = true }) => {
	const { t } = useTranslation();
	const { cjmIdStr } = useLocation()?.search.getMapsParams();

	const connector = useSelector((state) => state.settings.connector)?.getById(feedback?.connectorId) || {};
	const { enableConnection = true } = connector;
	const [toggle, setToggle] = useState(feedback?.stopRetrieveData);
	const loading = feedback?.customerFeedbackDatas?.length === 0 && (!feedback?.errorMsg || feedback?.errorMsg.isEmptyString());

	const handleChange = () => {
		setToggle(!toggle);
		upsertCustomerFeedback({ customerFeedback: { ...feedback, stopRetrieveData: !toggle, errorMsg: "" }, cjmId: cjmIdStr });
	};
	return (
		<>
			{loading ? (
				<div className="pt-1">
					<Styles.LabelCenter className="pt-3 mt-2">{t("START_RETRIEVING_DEC")}</Styles.LabelCenter>
					<Styles.LabelCenter className='pb-2' >{t("START_RETRIEVING_DEC1")}</Styles.LabelCenter>
					<div className="position-relative mt-5 ">
						<Spinner isFixed={false} />
					</div>
				</div>
			) : (
				<div className="py-4">
					{feedback?.errorMsg && feedback?.errorMsg !== "" && (
						<WrapperInfo type="error">
							<div>{IconDispatcher("triangle-exclamation", "", { style: "solid", color: "#D50000" })}</div>
							<Label size={12} color="#D50000">
								{t("ERROR")} : {feedback?.errorMsg}
							</Label>
						</WrapperInfo>
					)}
					{!enableConnection && (
						<WrapperInfo type="info">
							<div>{IconDispatcher("circle-info", "", { style: "solid", color: "#0078E7" })}</div>
							<Label size={12} color="#0078E7">
								{t("INFO_CONNECTOR_DISABLE")}
							</Label>
						</WrapperInfo>
					)}
					<Styles.StyledTable>
						<thead>
							<tr>
								<Styles.ThWrapper>
									<Label size={12}>{t("DATE")}</Label>
								</Styles.ThWrapper>
								<Styles.ThWrapper>
									<Label size={12}>{t("SENTIMENT_INDEX")}</Label>
								</Styles.ThWrapper>
								<Styles.ThWrapper>
									<Label size={12}>{t("ASPX_177")}</Label>
								</Styles.ThWrapper>
								<Styles.ThWrapper>
									<Label size={12}>{t("AVERAGE_RATING")}</Label>
								</Styles.ThWrapper>

							</tr>
						</thead>
						<tbody>
							{feedback?.customerFeedbackDatas
								.sort((a, b) => new Date(b.interactionDate) - new Date(a.interactionDate))
								?.map((feedbackData, index) => (
									<tr key={index}>
										<Styles.TdWrapper>
											<Moment className="ps-0" format="MMM DD, YYYY HH:mm:ss">
												{feedbackData?.interactionDate}
											</Moment>
										</Styles.TdWrapper>
										<Styles.TdWrapper>
											<EmotionLevelAndSmiley emotionLevel={feedbackData?.sentimentIndex || 0} />
										</Styles.TdWrapper>
										<Styles.TdWrapper>
											<Label>{feedbackData?.numberOfInteractions}</Label>
										</Styles.TdWrapper>
										<Styles.TdWrapper>
											<Label>{feedbackData?.averageRating}</Label>
										</Styles.TdWrapper>

									</tr>
								))}
						</tbody>
					</Styles.StyledTable>
					{showStopRetrieveData && (
						<div className="d-flex pt-5">
							<Label className="pe-4">{t("STOP_RETRIEVE_DATA")}</Label>
							<GenericSwitch isChecked={toggle} handleToggle={handleChange} />
						</div>
					)}
				</div>
			)}
		</>
	);
};
export const WrapperInfo = styled.div`
	margin-bottom: 1rem;
	display: flex;
	align-items: flex-start;
	${(props) =>
		props.type === "info" &&
		`
        border: 1px solid #CBE6FF;
        background: #EAF5FF;
    `}
	${(props) =>
		props.type === "error" &&
		`
        border: 1px solid #FFD2D2;
        background: #FFEDED;
    `}

    padding:4px;
	border-radius: 4px;
	gap: 8px;
`;
FeedBackData.propTypes = {
	feedback: PropTypes.shape({
		stopRetrieveData: PropTypes.bool,
		customerFeedbackDatas: PropTypes.array,
	}),
};
